export default {"src":"/_next/static/media/workspace.0a922461.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};